
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CemMultiFilter extends Vue {
    @Prop({ type: Array, default: () => [] }) value!: number[];
    @Prop({ type: Array, default: () => [] }) items!: any[];
    @Prop({ type: String, required: true }) label!: string;
    @Prop({ type: String, default: 'name' }) itemText!: string;
    timer: any = null;

    change(value: number[]) {
        this.$emit('input', value || []);
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.$emit('change'), 350);
    }
}
